import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';

import { webSocketSubscriber } from '@/shared/api/web-socket-subscriber';

import { queryKeys } from '../api/practice-member.queries';
import { sessionPermissionsUpdatedNotificationSchema } from './practice-member.schemas';

export function useAccessSourceUpdates() {
    const queryClient = useQueryClient();
    const router = useRouter();

    useEffect(() => {
        const invalidate = async () => {
            // 'all': guards use ensureQueryData, which serves an inactive query's stale entry.
            // The refetch must land before the router re-runs them.
            await queryClient.invalidateQueries({ queryKey: queryKeys.me(), refetchType: 'all' });
            await router.invalidate();
        };

        webSocketSubscriber.subscribe(sessionPermissionsUpdatedNotificationSchema, invalidate);

        return () => {
            webSocketSubscriber.unsubscribe(
                sessionPermissionsUpdatedNotificationSchema,
                invalidate,
            );
        };
    }, [queryClient, router]);
}
